var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false, design: "v3" },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "cancel-plan-information" }, [
        _c("div", { staticClass: "svg-banner" }, [_c("CancelPlan")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.cancelPlanConfirmTitle"))),
        ]),
        _vm._v(" "),
        _vm.planPeriod == "monthly"
          ? _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.cancelPlanMonthlyDesc")) +
                  "\n        "
              ),
            ])
          : _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.cancelPlanYearlyDesc")) +
                  "\n        "
              ),
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "SupsisButton",
              { staticClass: "footer-btn", on: { click: _vm.close } },
              [_vm._v("İptal")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                staticClass: "footer-btn",
                attrs: { danger: "" },
                on: { click: _vm.confirm },
              },
              [
                _vm.loading
                  ? _c("a-icon", { attrs: { type: "loading" } })
                  : _c("span", [_vm._v(_vm._s(_vm.$t("message.yesCancel")))]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }